import { render, staticRenderFns } from "./accountantSummaryDeliveryProvince.vue?vue&type=template&id=1a1183a8"
import script from "./accountantSummaryDeliveryProvince.vue?vue&type=script&lang=js"
export * from "./accountantSummaryDeliveryProvince.vue?vue&type=script&lang=js"
import style0 from "./accountantSummaryDeliveryProvince.vue?vue&type=style&index=0&id=1a1183a8&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports